import swal from 'sweetalert2'

export default ({getState, dispatch}) => {
    return next => action => {
        if(action.type === 'SET_FAVOURITE_SPELLS'){
            let favSpells = getState().favouriteSpells
            if(favSpells.find(spell => spell.spell === action.favSpells.spell)){
                swal.fire({
                    imageUrl : 'https://66.media.tumblr.com/326958ce87bfbad76448c4847deb16fa/tumblr_pkmgo5JT3w1xytlr5o3_500.gifv',
                    text : 'This spell is already your favourite you bollocks!',
                    // background : 
                })
                return
            }
        }
        console.log('action --------- >',action)
        next(action)
    }
}
